import { useContext } from 'react'

import { useQuery } from '@redwoodjs/web'

import FilterMenu from 'src/components/Overlays/FiltersMenu/FilterMenu'
import { RecruitersContext } from 'src/context/RecruitersContext'
import { GET_JOB_LISTINGS_ONLY } from 'src/graphql/joblistings.graphql'
import { jobListingTypeOptions } from 'src/graphql/types/jobListings'
import { useCompanyLeadSourceOptions } from 'src/hooks/useCompanyLeadSourceOptions/useCompanyLeadSourceOptions'
import { formatLeadSourceFilterValue } from 'src/lib/leadSource.utils'
import { serializeDateRangeForUrl } from 'src/lib/url-date-range.utils'
import { setSearchParam } from 'src/lib/url-search-params.utils'

import DateRangeMenu from '../../components/Overlays/DateRangeMenu'

const FiltersBar = ({
  selectedRecruiters,
  setSelectedRecruiters,
  selectedJobListings,
  setSelectedJobListings,
  selectedLeadSources,
  setSelectedLeadSources,
  selectedJobTypes,
  setSelectedJobTypes,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) => {
  // In-use lead sources (link types + their names), fetched lazily when the
  // Lead Source submenu is opened — replaces the full static LinkType enum.
  const leadSourceFilter = useCompanyLeadSourceOptions()
  const recruiters = useContext(RecruitersContext)
  /**********************    QUERIES    **********************/

  const { data: jobListingsResponse } = useQuery(GET_JOB_LISTINGS_ONLY, {
    variables: {
      pageInfo: { offset: 0, limit: 100 },
      filters: {
        recruiters: selectedRecruiters,
      },
    },
  })

  const jobListingOptions =
    jobListingsResponse?.jobListings.items?.map((jl) => ({
      value: jl.jobListingId,
      label: jl.title,
    })) || []

  const updateUrl = (name: string, value: string) => {
    setSearchParam(name, value)
  }

  return (
    <div className="flex flex-row items-center gap-2">
      <FilterMenu
        filters={[
          {
            title: 'Employees',
            selected: selectedRecruiters,
            onChange: (value) => {
              setSelectedRecruiters(value)
              updateUrl('recruiters', value.join(','))
            },
            options: recruiters ? [...recruiters] : [],
          },
          {
            title: 'Job Listings',
            selected: selectedJobListings,
            onChange: (value) => {
              setSelectedJobListings(value)
              updateUrl('jobListings', value.join(','))
            },
            options: jobListingOptions ? [...jobListingOptions] : [],
          },
          {
            title: 'Lead Source',
            selected: selectedLeadSources,
            onChange: (value) => {
              setSelectedLeadSources(value)
              updateUrl('leadSources', value.join(','))
            },
            options: leadSourceFilter.options,
            isNested: true,
            loadData: leadSourceFilter.loadData,
            isLoaded: leadSourceFilter.isLoaded,
            formatValue: formatLeadSourceFilterValue,
          },
          {
            title: 'Job Type',
            selected: selectedJobTypes,
            onChange: (value) => {
              setSelectedJobTypes(value)
              updateUrl('jobTypes', value.join(','))
            },
            options: [...jobListingTypeOptions],
          },
        ]}
      />
      <DateRangeMenu
        minDate={new Date('2024-10-15T12:00:00.000Z')}
        startDate={startDate}
        endDate={endDate}
        handleChange={(value) => {
          setStartDate(value[0])
          setEndDate(value[1])
          updateUrl('dateRange', serializeDateRangeForUrl(value[0], value[1]))
        }}
      />
    </div>
  )
}

export default FiltersBar
